// Chakra imports
import {
	HStack,
	Text,
	Circle,
	Box,
	Flex,
	Stat,
	StatHelpText,
	StatLabel,
	StatNumber,
	Badge,
	useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import React from "react";
import { ArrowUpIcon } from "@chakra-ui/icons";

const MiniStatistics = ({ title, amount, percentage, icon }) => {
	const textColor = useColorModeValue("gray.700", "white");

	return (
		<Card minH="150px" bg="#33333B">
			<CardBody>
				<Flex flexDirection="column" justify="center" w="100%">
					<Box>
						<HStack>
							<Circle
								size="70px"
								bgGradient="linear(to-r, #71C9EC, #833FB4)"
								color="white"
							>
								<img src={icon} />
							</Circle>
							<Text>Total Requests</Text>
						</HStack>
					</Box>
					<Stat me="auto" mt={3}>
						<Flex>
							<StatNumber fontSize="lg" color={textColor}>
								{amount}
							</StatNumber>
							<Badge
								alignSelf="center"
								justifySelf="center"
								ms={4}
								borderRadius="10px"
								py={1}
								px={2}
								color={percentage > 0 ? "green.400" : "red.400"}
								fontWeight="bold"
								fontSize="md"
							>
								<Flex align="center" gap={2}>
									<ArrowUpIcon
										boxSize={5}
										transform={
											percentage > 0 ? "rotate(45deg)" : "rotate(125deg)"
										}
									/>
									<Text>
										{percentage > 0 ? `${percentage}%` : `${percentage}%`}
									</Text>
								</Flex>
							</Badge>
						</Flex>
					</Stat>
				</Flex>
			</CardBody>
		</Card>
	);
};

export default MiniStatistics;
